// extracted by mini-css-extract-plugin
module.exports = {"shadow":"CarouselShadow_shadow___fzLp","shadow-end":"CarouselShadow_shadow-end__dzP_b"};